export default {
  methods: {
    prettyVehicleName: function(vehicle) {
      return vehicle
        .replace(/^ICE(0)?/, 'Tz ')
        .replace(/^ICD/, 'Tz ')
        .replace(/^ICK/, 'Tz ')
        .replace(/^91806(\d{3})(\d{3})(\d)/, '$1 $2-$3');
    },
  },
};
